import Vue from 'vue'

import {
  dateTime
} from './dateTime.js';

Vue.filter('dateFormate', (value, type) => {
  // 数据为空
  if (!value) return '--';

  if (("" + value).indexOf("-") > 0) {
    return value;
  }

  if (!type) {
    type = 0;
  }

  return dateTime(value, type);

})



// WEBPACK FOOTER //
// ./src/util/dateFormateFilter.js